/** @jsx jsx */
import { jsx } from '@emotion/core';
import Button from '@atlaskit/button';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { fontSize } from '@atlaskit/theme/constants';
import { R300 } from '@atlaskit/theme/colors';
import { Frame } from '../components/Frame';
import { gs } from '../utils';
export var ErroredView = function (_a) {
    var onRetry = _a.onRetry, _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, testId = _a.testId;
    return (jsx(Frame, { compact: true, isSelected: isSelected, testId: testId },
        jsx(ErrorIcon, { size: "small", primaryColor: R300, label: "error-icon" }),
        jsx("span", { css: {
                fontSize: fontSize() + "px",
                marginLeft: gs(0.5),
                marginRight: gs(0.5),
            } }, "We couldn't load this link for some reason."),
        jsx(Button, { testId: "err-view-retry", appearance: "link", spacing: "none", onClick: onRetry }, "Try Again")));
};
//# sourceMappingURL=ErroredView.js.map